const splitMarkerString = (value) => {
  if (typeof value !== "string") {
    return [];
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return [];
  }

  try {
    const parsed = JSON.parse(trimmed);
    if (Array.isArray(parsed)) {
      return parsed;
    }
    if (typeof parsed === "string") {
      return parsed.split(",");
    }
    if (parsed === null || parsed === undefined) {
      return [];
    }
    return [parsed];
  } catch {
    return trimmed.replace(/^['"]|['"]$/g, "").split(",");
  }
};

export const normalizeMarkerIds = (rawMarkers) => {
  const sourceItems = Array.isArray(rawMarkers)
    ? rawMarkers
    : rawMarkers === null || rawMarkers === undefined
      ? []
      : splitMarkerString(rawMarkers);

  const normalizedIds = [];
  const seenIds = new Set();

  sourceItems.forEach((item) => {
    const asString = String(item ?? "").trim();
    if (!asString || asString === "null" || asString === "undefined") {
      return;
    }

    asString.split(",").forEach((chunk) => {
      const markerId = String(chunk ?? "").trim();
      if (!markerId || markerId === "null" || markerId === "undefined") {
        return;
      }

      if (!seenIds.has(markerId)) {
        seenIds.add(markerId);
        normalizedIds.push(markerId);
      }
    });
  });

  return normalizedIds;
};

export const areMarkerListsEqual = (firstList = [], secondList = []) => {
  if (firstList.length !== secondList.length) {
    return false;
  }

  for (let index = 0; index < firstList.length; index += 1) {
    if (String(firstList[index]) !== String(secondList[index])) {
      return false;
    }
  }

  return true;
};

export const resolveTokenMarkerSources = (videoListPayload = {}) => {
  const primaryMarkers = normalizeMarkerIds(videoListPayload?.all_markers);
  const fallbackMarkers = normalizeMarkerIds(videoListPayload?.markers);
  const usePrimaryMarkers = primaryMarkers.length > 0;

  return {
    primaryMarkers,
    fallbackMarkers,
    selectedMarkers: usePrimaryMarkers ? primaryMarkers : fallbackMarkers,
    selectedSource: usePrimaryMarkers
      ? "all_markers"
      : fallbackMarkers.length > 0
        ? "markers"
        : null,
  };
};
